export default __webpack_public_path__ + "static/media/12.2136a68e.jpg";